import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const formats = [
  { text: "E164+", key: "e164p", value: "e164p" },
  { text: "E164", key: "e164", value: "e164" },
  { text: "National", key: "national", value: "national" },
];

const CallFormatSelect = ({ label, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        name={field.name}
        defaultValue={field.value}
        clearable
        fluid
        search
        selection
        options={formats}
        placeholder="Select Format"
        onChange={(event, { value }) => {
          helpers.setValue(value);
        }}
      />
      {meta.error && (
        <Label basic color="red" pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default CallFormatSelect;
